import React from 'react';

const SvgGraph = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 19 18" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Graph_svg__a"
        d="M344.833 275.752l.998 1.498h4.002v4.588H336.5v-4.588h2.664l2.336 3.507zm-8.333-5.584h13.333v4.589h-2.664l-2.336-3.507-3.333 5.005-.998-1.498H336.5zm-2.5 14.169h18.333V267.67H334z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Graph_svg__a" transform="translate(-334 -267)" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgGraph svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Graph.js